<script setup lang="ts">
/**
 * The template's "More details →" affordance: on hover the arrow slides out to
 * the right while a second one slides in from the left.
 *
 * Rendered inline so it can sit inside a card that is itself a link; pass
 * `as="span"` in that case. Uses Bootstrap Icons, already loaded site-wide, so
 * no second icon font is needed.
 */
import { LocaleLink } from '#components'

withDefaults(defineProps<{
  label: string
  /**
   * Read by search engines and screen readers after the label, e.g. the
   * article title behind a "Read more", so the link says where it goes.
   */
  srSuffix?: string
  to?: string
  /** Use `span` when the whole card is already an anchor. */
  as?: 'span' | 'link'
}>(), {
  as: 'link',
})
</script>

<template>
  <component
    :is="as === 'link' ? LocaleLink : 'span'"
    :to="as === 'link' ? to : undefined"
    class="group/arrow inline-flex items-center gap-2 font-semibold text-ink dark:text-white"
  >
    <span class="transition-all duration-300">{{ label }}<span v-if="srSuffix" class="sr-only">: {{ srSuffix }}</span></span>
    <span class="relative inline-flex size-4 items-center justify-center overflow-hidden">
      <i class="bi bi-arrow-right absolute transition-transform duration-300 group-hover/arrow:translate-x-full group-hover:translate-x-full" />
      <i class="bi bi-arrow-right absolute -translate-x-full transition-transform duration-300 group-hover/arrow:translate-x-0 group-hover:translate-x-0" />
    </span>
  </component>
</template>
